import React, { useState } from 'react';
import axios from 'axios';

const ValuationForm = ({ assetId, onClose }) => {
    const [valuationType, setValuationType] = useState('');
    const [value, setValue] = useState('');
    const [valueSource, setValueSource] = useState('');
    const [date, setDate] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        const valuationData = {
            value,
            value_source: valueSource,
            date,
            asset: assetId, // Use the asset ID for foreign key
        };

        let url;

        if (valuationType === 'Book Value') {
            url = '/api/balance_sheet/assets/book-valuations/';  // API endpoint for book valuations
        } else if (valuationType === 'Market Value') {
            url = '/api/balance_sheet/assets/market-valuations/'; // API endpoint for market valuations
        } else {
            console.error('Invalid valuation type');
            return; // Exit if the valuationType is not valid
        }

        console.log('Selected Valuation Type:', valuationType);
        console.log('Submitting Valuation Data:', valuationData);
        console.log('URL:', url);

        try {
            await axios.post(url, valuationData);
        } catch (error) {
            console.error('Error submitting valuation:', error);
            alert(error.response?.data?.detail || error.message || 'Failed to submit valuation');
        }

        // Optionally close the form and refresh valuations or handle further actions
        onClose();
    };

    return (
        <form onSubmit={handleSubmit} className="valuation-form">
            <div className="form-row">
                <label htmlFor="valuationType">Valuation Type:</label>
                <select
                    id="valuationType"
                    value={valuationType}
                    onChange={(e) => setValuationType(e.target.value)}
                    required
                >
                    <option value="" disabled>Select Valuation Type</option>
                    <option value="Book Value">Book Value</option>
                    <option value="Market Value">Market Value</option>
                </select>
            </div>
            <div className="form-row">
                <label htmlFor="value">Value:</label>
                <input
                    type="number"
                    step="0.01"
                    id="value"
                    placeholder="Value"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    required
                />
            </div>
            <div className="form-row">
                <label htmlFor="valueSource">Value Source:</label>
                <input
                    type="text"
                    id="valueSource"
                    placeholder="Value Source"
                    value={valueSource}
                    onChange={(e) => setValueSource(e.target.value)}
                    required
                />
            </div>
            <div className="form-row">
                <label htmlFor="date">Date:</label>
                <input
                    type="date"
                    id="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    required
                />
            </div>
            <div className="form-row">
                <div></div>
                <button type="submit" className="btn btn-primary">Submit</button>
            </div>
        </form>
    );
};

export default ValuationForm;